import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { State } from 'src/app/enums/state.enum';
import { EventResource } from 'src/app/interfaces/event-resource';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TooltipPosition } from '@angular/material/tooltip';
import { switchMap } from 'rxjs/operators';
import { Interest } from 'src/app/interfaces/interest';
import { Observable, of } from 'rxjs';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { ContractService } from 'src/app/services/contract.service';
import { McpService } from 'src/app/services/mcp.service';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent implements OnInit {
  /**
   * The PageMetadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * The current Config
   */
  config: any;
  /**
   * Is the Page Loaded
   */
  loaded: boolean = false;
  /**
   * The current list of Partners
   */
  partners = [];
  /**
   * All Partners
   */
  Allpartners = [];
  /**
   * Finished the Loading
   */
  finishedLoading: boolean = false;
  /**
   * The Position of the Tooltip
   */
  postoolTip: TooltipPosition = "above";
  /**
   * The filtered Partners
   */
  filteredOptions: Observable<string[]>;

  /**
   * Has the mandant AdvancedEventDetails
   */
  hasAdvancedEventDetails: boolean = false;
  /**
   * The Sortdirections for the Date
   */
  public sortOptions: SortOption[] = [
    { value: 'dateAsc', viewValue: 'Datum Absteigend' },
    { value: 'dateDesc', viewValue: 'Datum Aufsteigend' },
  ];
  /**
   * The State of the Event
   */
  public sortOptionsState: SortOption[] = [
    { value: 'CREATED', viewValue: 'In Freigabe' },
    { value: 'DRAFT', viewValue: 'Entwurf' },
    { value: 'PREVIEW', viewValue: 'Vorschau' },
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'HIDDEN', viewValue: 'Versteckt' },
    { value: 'CANCELLED', viewValue: 'Abgelehnt' },
    { value: 'EXPIRED', viewValue: 'Abgelaufen' },
    { value: 'ARCHIVED', viewValue: 'Archiviert' },
    { value: 'DELETED', viewValue: 'Gelöscht' },
  ];
  /**
   * THe Types of DiscountTypes
   */
  public sortOptionsDiscountType: SortOption[] = [
    { value: 'MONETARY', viewValue: 'Preisvorteil' },
    { value: 'SERVICE_PLUS', viewValue: 'Exklusiv' },
    { value: 'EXTERNAL_EVENT', viewValue: 'Partneraktion' },
    { value: 'RAFFLE', viewValue: 'Gewinnspiel' }
  ];
  /**
   * The current Page
   */
  page = null;
  /**
   * All Events
   */
  public allEvents = [];
  /**
   * THe Form to filter the Events
   */
  public filterForm: UntypedFormGroup;
  /**
   * Init the Form
   * @param eventService 
   * @param overlayService 
   * @param fb 
   * @param router 
   * @param mcp 
   * @param contractService 
   * @param route 
   */
  constructor(
    private eventService: EventService,
    private overlayService: OverlayService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private mcp: McpService,
    private contractService: ContractService,
    private route: ActivatedRoute) {
    this.filterForm = this.fb.group({
      searchTerm: [, []],
      filterState: [[]],
      filterDiscountType: [[]],
      filterByPartners: [[]],
      serachTermPartners: [[]],
      filterByPartnersIDs: [[]],
    })

    this.mcp.loadConfiguration().subscribe(config => {
      this.config = config;
    })
    this.route.queryParams.subscribe((params: Params) => {
      if (params['filterState']) {
        this.filterForm.markAllAsTouched();
        this.filterForm.patchValue({
          searchTerm: params['searchTerm'],
          filterState: [params['filterState']],
          filterDiscountType: [params['filterDiscountType']],
        })
      }
    });
  }


  /**
   * load the First Events
   */
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterState: ((params?.filterState != '') ? params?.filterState?.split(',') : null),
        filterDiscountType: ((params?.filterDiscountType != '') ? params?.filterDiscountType?.split(',') : null),
        // serachTermPartners: params?.serachTermPartners,
        //filterByPartners: params?.filterByPartners,
        filterByPartnersIDs: params?.filterByPartnersIDs,
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })

    this.contractService.hasAdvancedEventDetails$.subscribe({
      next: res => {
        this.hasAdvancedEventDetails = Boolean(res);
      },
      error: error => {
        console.log(error)
      }
    })
    this.filterEvents();
    this.eventService.getPartners().subscribe((partners: PagedResources<BusinessEntityResource>) => {
      this.partners = partners.content;
      this.Allpartners = partners.content;
    })
    this.filterForm.controls.serachTermPartners.valueChanges.subscribe(val => {
      this.autoCompletePartners(val)
    })
  }
  /**
   * Get the Page of Events
   * @param event 
   * @returns 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    return this.filterEvents();
  }
  /**
   * Get the Page of Events
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.eventService.mergeEventsFromV1andV2(pageIndex, pageSize, this.filterForm.value.filterState, this.filterForm.value.filterDiscountType, this.filterForm.value.filterByPartnersIDs, this.filterForm.value.emailFormControl).subscribe((value: any) => {
      this.page = value.page
      this.allEvents = value.content;
    })
  }
  /**
   * Disable the Event
   * @param event 
   */
  disable(event: EventResource) {
    event.state = State.ARCHIVED;
    event.clientRef = event.eventPartner.clientRef;
    this.eventService.disableEvent(event).subscribe(resDisable => {
      this.overlayService.openSnackBar('Aktion wurde erfolgreich deaktiviert/archiviert!');
      //slice Element from Array
      //TODO check if this works with the filters in the future
      this.allEvents.splice(this.allEvents.indexOf(event), 1)
    })
  }
  /**
   * Filter the Events
   */
  filterEvents() {
    this.finishedLoading = false;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterState: this.filterForm.value?.filterState?.join(),
          filterDiscountType: this.filterForm.value?.filterDiscountType?.join(),
          // serachTermPartners: this.filterForm.value?.serachTermPartners,
          filterByPartnersIDs: this.convertPartnerObjToIDs(this.filterForm.value?.filterByPartners, this.filterForm.value?.filterByPartnersIDs),
          page: this.pageData.pageIndex,
          size: this.pageData.pageSize
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.setselectedPartners(this.filterForm.value?.filterByPartnersIDs);
        this.eventService.mergeEventsFromV1andV2(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.filterState, this.filterForm.value.filterDiscountType, this.filterForm.value?.filterByPartnersIDs, this.filterForm.value.searchTerm).subscribe((value: PagedResources<EventResource>) => {
          value.content.forEach((element: EventResource) => {
            this.eventService.getReservationCountToEventID(0, 1, ["ACTIVE"], element.publicId).subscribe((count: PagedResources<EventResource>) => {
              element['attendanceCount'] = count.page.totalElements
            })
          });
          this.page = value.page
          this.allEvents = value.content;
          //pagemeta data from previous search is set wrong (e.g. page 3 if there is only 1 page)
          if ((this.page.number * this.page.size) > this.page.totalElements) {
            this.pageData = {
              pageIndex: 0,
              pageSize: 12
            }
            this.filterEvents();
          } else {
            this.finishedLoading = true;
          }
        })
      })
  }
  /**
   * Download The ReservationList as vnd.ms-excel
   * @param event 
   */
  downloadReservationList(event: EventResource) {
    this.eventService.downloadReservationList(event).subscribe(bal => {
      var a = document.createElement("a");
      const contentType = 'application/vnd.ms-excel';
      const blob = new Blob([bal], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Reservierungsliste";
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }
  /**
   * Open the BottomSheet to change the State
   * @param event 
   */
  openStateChangeBottomSheet(event) {
    this.overlayService.openBottomSheet(event).subscribe(() => {
      this.filterEvents();
    })
  }
  /**
   * Reset the Filter
   */
  resetFitler() {
    this.filterForm.reset();
    this.search(this.pageData.pageIndex, this.pageData.pageSize)
  }
  /**
   * Open the reservations
   * @param event 
   */
  moveToReservations(event: EventResource) {
    this.router.navigate(['caseworker/reservation'], { queryParams: { eventPublicId: event.publicId } })
  }
  /**
   * Open the pushmessages
   * @param event 
   */
  moveToPush(event: EventResource) {
    this.router.navigate(['caseworker/pushmessages/add'], { queryParams: { eventPublicId: event.publicId, type: 'EVENTS' } })
  }
  /**
   * Open the BulkImport
   * @param event 
   */
  moveToBulkImport(event: EventResource) {
    this.router.navigate(['caseworker/bulk'], { queryParams: { eventPublicId: event.publicId } })
  }
  /**
   * Open the SmartQuick
   * @param event 
   */
  moveToSmartQuick(event: EventResource) {
    this.router.navigate(['caseworker/smartquick'], { queryParams: { eventPublicId: event.publicId } })
  }
  /**
   * Open the Bulkupdate Dialog
   */
  bulkUpdateEvents() {
    this.overlayService.openAutoUpdateEventStatusComponent("Hinweis", "", "Update", "Abbrechen").subscribe({
      next: res => {
        console.log(res)
        if (res == true) {
          this.filterEvents()
        }
      }, error: err => {
        console.error(err)
      }
    })
  }
  /**
   * Update the auto state change
   * @param event 
   * @param newAutoState 
   */
  changeAutoStateChange(event: EventResource, newAutoState: boolean) {
    event.autoStatus = newAutoState;
    this.eventService.editEvent(event).subscribe((formChange: EventResource) => {
      event = formChange;
    })
  }
  /**
   * Duplicate an Event
   * @param event 
   */
  duplicateEvent(event: EventResource) {
    let oldId = event.publicId
    event.state = State.DRAFT;
    event.autoStatus = false;
    event.publicId = null;
    let fromDuplicateTemp: EventResource;
    this.eventService.createEvent(event).pipe(
      switchMap((fromDuplicate: EventResource) => {
        fromDuplicateTemp = fromDuplicate;
        console.log(event)
        return this.eventService.getInterestsForEvent(oldId);
      }),
      switchMap((interestFromOldEvent: PagedResources<Interest>) => {
        interestFromOldEvent.content.forEach(element => {
          this.eventService.addInterestToEvent(fromDuplicateTemp.publicId, element).subscribe(fromADD => {
          })
        });
        return of(true)
      })
    ).subscribe(val => {
      this.overlayService.openSnackBar("Aktion erfolgreich dupliziert!");
      this.filterEvents();
    })
  }
  /**
   * Open the QR Dialog to view the Event QR Code
   * @param event 
   */
  openQRDialog(event: EventResource) {
    this.overlayService.openQrCodeDialog("Aktions QR-Code", "", "OK", event)
  }
  /**
   * Autocomplete the Partnersdropdown
   * @param value 
   */
  private autoCompletePartners(value) {
    this.partners = this.Allpartners;
    if (value != '' && value != null) {
      this.partners = this.Allpartners;
      const filterValue = value.toLowerCase();
      this.partners = this.partners.filter(option => option.name.toLowerCase().includes(filterValue));
    }
  }
  /**
   * Reset the searchinput for Partners
   */
  clearSearchField() {
    this.filterForm.controls.serachTermPartners.reset()
  }
  /**
   * Open the Event on the customerpage
   * @param event 
   */
  moveToCustomerView(event: EventResource) {
    this.mcp.loadConfiguration().subscribe(config => {
      if(config.mandantid == '125'){
        window.open(`${config.shareURL}/benefits/events/${event.publicId}`)
      }else{
        window.open(`${config.shareURL}/app/${config.mandantid}/benefits/event/${event.publicId}`)
      }
 
    })
  }
  /**
   * Filter when the EnterKey is pressed
   * @param event 
   */
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterEvents()
    }
  }

  setPartnerForSelect(o1, o2): boolean {
    return o1.name === o2.name;
  }

  private convertPartnerObjToIDs(partner: any, valueFromURL: String): String {
    if (partner == undefined) {
      return null;
    }
    if (valueFromURL != undefined && valueFromURL != '' && partner.publicId != undefined) {
      if (partner.publicId == valueFromURL) {
        return valueFromURL;
      } else {
        return partner.publicId;
      }
    } else {
      if (partner.publicId != undefined) {
        return partner.publicId;
      } else {
        return valueFromURL
      }
    }
  }

  setselectedPartners(partnerParamID: String) {
    this.eventService.getPartners().subscribe((partners: PagedResources<BusinessEntityResource>) => {
      this.partners = partners.content;
      this.partners.forEach(partner => {
        if (partner.publicId == partnerParamID) {
          this.filterForm.patchValue({
            filterByPartners: partner
          })
        }
      });
    });
  }

  /**
   * Open the Dialog to change the Eventlimits
   */
  updateEventStateLimits() {
    this.overlayService.openEventStateLimits("Aktionstatus Zeiträume festlegen", "Limits ändern", "Abbrechen").subscribe({
      next: res => {
        if (res == true) {
          this.filterEvents()
        }
      }
    })
  }
}
